import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=40ea5f36&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"
import style0 from "./solution.vue?vue&type=style&index=0&id=40ea5f36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea5f36",
  null
  
)

export default component.exports